module.exports = __webpack_public_path__ + "static/media/arrow-left-black.2e3491e7.svg";